import * as React from 'react'
export const EmailIcon = () => {
  return (
    <svg width='23' height='19' viewBox='0 0 23 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.0605 2.79199L10.8955 9.2373L0.00878915 2.9502C0.114258 1.30371 1.48242 0 3.15527 0H18.9258C20.5459 0 21.8818 1.21875 22.0605 2.79199ZM22.0811 5.10059V14.9121C22.0811 16.6553 20.6689 18.0674 18.9258 18.0674H3.15527C1.41211 18.0674 0 16.6553 0 14.9121V5.26758L10.3975 11.2705C10.7549 11.4756 11.1855 11.4375 11.4961 11.209C11.5107 11.2031 11.5225 11.1943 11.5371 11.1855L22.0811 5.10059Z'
        fill='current'
      />
    </svg>
  )
}
